import { ILoginUsuario } from 'src/app/authentication/models/UserSession.model';
import * as storage from '../../../core/store/root/storage';
export const LocalidadFeatureKey = "localidades";
export interface IUsuarioState {
   usuario: ILoginUsuario;
}

export const initialUsuarioState: IUsuarioState = {
  usuario: storage.getItem('LoggedUser'),
};
